import { render, staticRenderFns } from "./SitesProgrammesList.vue?vue&type=template&id=18d4c242&scoped=true&"
import script from "./SitesProgrammesList.vue?vue&type=script&lang=js&"
export * from "./SitesProgrammesList.vue?vue&type=script&lang=js&"
import style0 from "./SitesProgrammesList.vue?vue&type=style&index=0&id=18d4c242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4c242",
  null
  
)

export default component.exports